import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { Store } from 'src/app/core/store/store';
import { ProfileService } from 'src/app/modules/dashboard/profile/service/profile.service';
import { User } from 'src/app/shared/models/user.model';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { timezoneData } from 'src/app/shared/utils/timezone';
import {element} from 'protractor';
@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.css']
})
export class NewHeaderComponent implements OnInit {
  @ViewChild('search') searchElement: ElementRef;
  @ViewChild('searchTimezone') searchElementTimezone: ElementRef;
  hidePartnerLogo = false;
  user: User;
  lastSync: any;
  nextSync: any;
  hideSidebar = false;
  currentOrganization: string;
  currentActivation: string;
  organizations: string[];
  activations: { _id: string, title: string, startdate: any, programid: string }[] = [];
  activationDropDown = ''
  organizationSelected: any = null
  timezoneSelected: any = null
  activationDropdown = ''
  activationSelected: any = ''
  public filteredList: any = [];
  timezoneDrop = timezoneData;
  timezoneObj = this.timezoneDrop.find(x => x.value == '+5:30')
  defaultTimezone = `${this.timezoneObj.label}`;
  filteredTimezone: any;
  constructor(private store: Store, private partnerService: PartnerService, private profileService: ProfileService) {
  }

  getDateFormat = (dateNode) => {

    if (dateNode?.value) {
      const date = dateNode.value;
      const partsWithoutTimeZone = date.split('T');
      const parts = partsWithoutTimeZone[0].split('-');

      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    else {
      return '-';
    }
  }

  getDateLongFormat = (dateNode) => {

    if (dateNode) {
      const date = parseInt(dateNode);
      return moment(date).format('DD MMM YYYY');
    }
    else {
      return '-';
    }
  }
  delay = ms => new Promise(res => {
    this.store.set('elementLoader', true);
    setTimeout(res, ms)
  });

  onActivationChange = (activation: string) => {
    this.store.set('currentActivation', activation);
    sessionStorage.setItem('currentActivation', activation);
    this.activationSelected = this.getActivationTitle(activation);
    this.store.set('currentActivationTitle', this.activationSelected);

  }

  generateTitle = (activation: any) => {
    return activation.title + ' (' + this.getDateLongFormat(activation.start) + ')';
  }

  getActivationTitle = (activationId: string) => {
    const activationFiltered = this.activations?.filter((a) => a._id === activationId);
    if (activationFiltered?.length > 0) {
      return activationFiltered[0].title;
    }

    return '';
  }

  onOrganizationChange = (organization: string) => {
    this.store.set('loader', true)
    this.store.set('currentOrganization', organization);
    sessionStorage.setItem('currentOrganization', organization);

    this.organizationSelected = organization
  }

  onTimezoneChange = (timezone: string) => {

    this.setTimeZone(timezone);
  }

  ngOnInit(): void {

    this.store.select<User>('user').subscribe((user) => {
      if (user) {
        this.user = user;
        this.setInitialTimezone();
      }
    });

    this.store.select<string[]>('organizations').subscribe((organizations) => {
      this.organizations = organizations;
      if (organizations && (this.organizationSelected === null || this.organizationSelected === undefined)) {
        const sessionOrganization = sessionStorage.getItem('currentOrganization');
        let org = sessionOrganization || organizations[0];
        this.organizationSelected = org;
        this.filteredList = this.organizations;
      }
    });
    this.filteredTimezone = this.timezoneDrop;


    this.store.select<{ _id: string, title: string, startdate: any, programid: string }[]>('activations').subscribe((activations) => {
      this.activations = activations;
    });

    this.store.select<string>('currentOrganization').pipe(distinctUntilChanged()).subscribe((organization) => {
      this.currentOrganization = organization;
      if (organization) {
        this.partnerService.getActivations(organization).subscribe(res => {
          if (res && res.length > 0) {
            const sessionActivation = sessionStorage.getItem('currentActivation');
            let act = res[0]._id;

            if (sessionActivation) {
              act = sessionActivation;
            }


            const activationList = res.map((r) => ({ ...r, title: this.generateTitle(r) }))
            this.store.set('activations', activationList);
            const filteredActivationList = activationList.filter((a) => a._id === act);


            const activationObject = filteredActivationList && filteredActivationList.length > 0 ? filteredActivationList[0] : activationList[0];

            this.store.set('currentActivation', activationObject._id);
            sessionStorage.setItem('currentActivation', activationObject._id);


            this.activationSelected = activationObject.title;
            this.store.set('currentActivationTitle', this.activationSelected);
          }
        });
      }
    });
    this.store.select<string>('currentActivation').pipe(distinctUntilChanged()).subscribe(async (activation) => {

      this.currentActivation = activation;
      this.activationDropdown = this.getActivationTitle(activation);
      if (activation) {
        this.partnerService.getDashboard(this.currentOrganization, this.currentActivation).subscribe(res => {
          if (res) {
            this.lastSync = res?.lastSync[0][0]['lastSync']?.value;
            this.store.set('metrics', res);
          }
        });

        await this.delay(3000);

        this.partnerService.getElements(this.currentOrganization, this.currentActivation).subscribe(res => {
          if (res) {
            res.learnerDetails = Array.from(new Set(res?.learnerDetails))
            this.store.set('elements', res);
            let learnerDetailMap = {};
            res?.learnerDetails.forEach( (element:any) => {
              if (learnerDetailMap[element?.email]){
                learnerDetailMap[element?.email][element?.item_title] = element;
                learnerDetailMap[element?.email].timeSpent += element.spenttime;
              }else {
                learnerDetailMap[element?.email] = {};
                learnerDetailMap[element?.email][element?.item_title] = element;
                learnerDetailMap[element?.email].timeSpent = element.spenttime;
              }
            });
            this.store.set('learnerDetailMap', learnerDetailMap );
          }
        });


      }
    });
  }
  timezoneSet: boolean = false;
  setInitialTimezone() {
    if (this.user && this.user['timeZone'].length > 0 && !this.timezoneSet) {
      this.timezoneSelected = this.timezoneDrop.filter(
        timezone => timezone.value.toLowerCase().indexOf(this.user['timeZone']) > -1
      )[0].label;
      // this.timezoneSelected= '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi'
      this.store.select('userTimeZone').subscribe(res => {
        if (res != this.user['timeZone']){
          this.store.set('userTimeZone', this.user['timeZone']);
        }
      })
      sessionStorage.setItem('userTimeZone', this.user['timeZone']);
      this.timezoneSet = true;
    } else {
      this.timezoneSelected = '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi'
      // this.store.set('userTimeZone', '+5:30');
      this.store.select('userTimeZone').subscribe(res => {
        if (res != this.user['timeZone']){
          this.store.set('userTimeZone', '+5:30');
        }
      })
      sessionStorage.setItem('userTimeZone', '+5:30');
      this.timezoneSet = true;
    }
  }

  filterDropdown(e) {
    window.scrollTo(window.scrollX, window.scrollY + 1);
    let searchString = e.toLowerCase();
    if (!searchString) {
      this.filteredList = this.organizations.slice();
      return;
    } else {
      this.filteredList = this.organizations.filter(
        organization => organization.toLowerCase().indexOf(searchString) > -1
      );
    }
    window.scrollTo(window.scrollX, window.scrollY - 1);
  }
  filterTimeZone(e) {
    window.scrollTo(window.scrollX, window.scrollY + 1);
    let searchString = e.toLowerCase();
    if (!searchString) {
      this.filteredTimezone = this.timezoneDrop.slice();
      return;
    } else {
      this.filteredTimezone = this.timezoneDrop.filter(
        timezone => timezone.label.toLowerCase().indexOf(searchString) > -1
      );
    }
    window.scrollTo(window.scrollX, window.scrollY - 1);
  }

  setFocus() {
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 0);
  }

  setFocusTimezone() {
    setTimeout(() => {
      this.searchElementTimezone.nativeElement.focus();
    }, 0);
  }

  setTimeZone(timezone) {
    this.profileService.updateTimezone({ isTimeZoneConfirmed: true, timeZone: timezone['value'] }).subscribe(res => {
      if (res) {
        this.store.set('userTimeZone', timezone['value']);
        sessionStorage.setItem('userTimeZone', timezone['value']);
        this.timezoneSelected = timezone['innerText'];
      } else {

      }
    });
  }
  get nextSyncDate() {
    const originalDate = new Date(this.lastSync);
    originalDate.setHours(originalDate.getHours() + 12);
    this.nextSync = originalDate.toISOString();
    return this.nextSync

  }
}
